/** Última ciudad (id numérico como string) o `__todas__` en ficha catálogo de edición — PropuestasPage. */
export const UBICACION_FICHA_EDICION_STORAGE_KEY = 'as_gastronomico_ultima_ubicacion_ficha_edicion';

/** Sesión: llegada a `/votar` desde el shell comensal `/app` (catálogo de vuelta en `/edicion/...`). */
export const VOTAR_ORIGEN_APP_SHELL_SESSION_KEY = 'as_gastronomico_votar_origen_app_shell';

/** Llamar antes de `navigate('/votar/...')` desde rutas bajo `/app`. */
export function marcarVotarDesdeAppShell(): void {
  if (typeof window === 'undefined' || !window.sessionStorage) return;
  try {
    window.sessionStorage.setItem(VOTAR_ORIGEN_APP_SHELL_SESSION_KEY, '1');
  } catch {
    /* ignore */
  }
}
